'use strict'

// The first text field is the username. The password field is the password.
// Login and registration forms both use that pair.

function listAuthInputs (component) {

  const fields = []

  const visit = (node) => {

    for (const sub of (node && node.components) || []) {

      if (!sub || typeof sub !== 'object') continue

      if (sub.type === 'formInput' || sub.type === 'formPassword') fields.push(sub)

      if (sub.components) visit(sub)
    }
  }

  visit(component)

  return fields
}

function credentialFields (component) {

  const fields = listAuthInputs(component)
  const username = fields.find((field) => field.type === 'formInput') || null
  const password = fields.find((field) => field.type === 'formPassword') || null

  return {
    usernameField: username && username.uniqueTitle ? username.uniqueTitle : null,
    passwordField: password && password.uniqueTitle ? password.uniqueTitle : null,
    extraFields: fields
      .filter((field) => field.type === 'formInput' && field !== username && field.uniqueTitle)
      .map((field) => field.uniqueTitle)
  }
}

module.exports = {
  listAuthInputs,
  credentialFields
}
